<template>
  <div id="app">
    <a href="#who-are-we" class="skip-link">Skip to main content</a>
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App",
    created(){
      this.$store.dispatch("loadData")
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Righteous&display=swap');
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&family=Jockey+One&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

$coral: coral;
:root{
  /* Brand Colors */
  --dark: #014141;
  --medium: #01696c;
  --regular: #02979d;
  --light: #48b0b3;
  --white: #fff;

  /* Text & Neutral Colors */
  --text-dark: #002f50;
  --text-muted: #676767;

  /* Typography */
  --font-title: 'Prompt', sans-serif;
  --font-accent: 'Righteous', cursive;
  --font-weight: 450;
  --font-body: 'Montserrat', Avenir, Helvetica, sans-serif;
  --font-h3: 'Montserrat', Helvetica, sans-serif;

  /* Layout & Container Standards */
  --max-width: 100rem;
  --section-padding: 10%;
  --section-padding-mobile: 6%;

  /* Grid Gaps */
  --grid-gap-desktop: 2.5rem;
  --grid-gap-tablet: 2rem;
  --grid-gap-mobile: 1.5rem;

  /* Border Radii & Transitions */
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
  --border-radius-lg: 16px;
  --border-radius-full: 9999px;
  --transition-fast: 0.2s ease-in-out;
  --transition-smooth: 0.3s ease-in-out;
}

html{
  height: -webkit-fill-available;
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

[id] {
  scroll-margin-top: 5rem;
}

body{
  min-height: 100vh;
  min-height: -webkit-fill-available;
  margin: 0;
  padding: 0;
  font-weight: var(--font-weight);
  overflow-x: hidden;
}

#app {
  font-family: var(--font-body);
  font-weight: var(--font-weight);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--medium);
  line-height: 1.35;
  overflow-x: hidden;
  width: 100%;
}

p {
  line-height: 1.35;
}

* {
  // border: 1px dashed red;
  box-sizing: border-box;
}

h2{
  font-family: var(--font-title);
  font-size: 24pt;
  margin-top: 0em;
  margin-bottom: 0em;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--regular);
  color: white;
  padding: 8px;
  z-index: 100;
  text-decoration: none;
  transition: top var(--transition-smooth);
  font-weight: bold;
  border-radius: 0 0 var(--border-radius-sm) 0;
}

.skip-link:focus {
  top: 0;
  outline: 2px solid var(--white);
  outline-offset: -2px;
}

.header-link {
  color: inherit;
  text-decoration: none;
  cursor: default;
  
  &:hover {
    text-decoration: none;
  }
  
  &:focus {
    text-decoration: none;
    outline: 2px dashed var(--regular);
    outline-offset: 4px;
    border-radius: var(--border-radius-sm);
  }
}

h3 {
  font-family: var(--font-h3);
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  h2 {
    font-size: clamp(1.4rem, 5.5vw, 1.85rem);
  }

  h3 {
    font-size: clamp(1.1rem, 4vw, 1.3rem);
  }
}

</style>
